import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthProvider";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { LoadScript } from "@react-google-maps/api";
import { Provider } from "react-redux";
import store from "./store/store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LoadScript
          googleMapsApiKey={"AIzaSyAjWAttLzOFNw-GjKMxxUP8fFq8bSkprNY"}
          libraries={["places", "streetView"]}
        >
          <ToastContainer />
          <Provider store={store}>
            <App />
          </Provider>
        </LoadScript>
      </AuthProvider>
    </BrowserRouter>
    {/* <AuthContextProvider> */}

    {/* </AuthContextProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
